"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const zustandStore_1 = require("../../../zustandStore");
const supportHeader_1 = __importDefault(require("./supportHeader"));
const SupportContainer = ({ children }) => {
    const { setHeaderName } = (0, zustandStore_1.useZustand)();
    const theme = (0, material_1.useTheme)();
    (0, react_1.useEffect)(() => {
        setHeaderName('Support Settings');
    }, [setHeaderName]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(supportHeader_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Container, { "data-testid": "support-settings-container", style: {
                    overflow: 'auto',
                    height: '100vh',
                    maxWidth: '100vw',
                    padding: `${theme.tsGoUnit.tsUnitDouble}`,
                    backgroundColor: `${theme.palette.tsGoColor.grayLightest}`,
                }, children: children })] }));
};
exports.default = SupportContainer;
